import React from 'react';
import { Tabs, Tab } from '@mui/material';
import globalStyles from '../../Styles/ComponentStyles/global.module.scss';

type TabValue = string;

interface ProfileTabConfig {
    label: string;
    value: TabValue;
}

interface GlobalTabsComponentProps {
    value: TabValue;
    onChange: (event: React.SyntheticEvent, newValue: TabValue) => void;
    tabs: ProfileTabConfig[];
    normalColor?: string;
    selectedColor?: string;
    indicatorColor?: string;
}


const GlobalTabsComponent: React.FC<GlobalTabsComponentProps> = ({
    value,
    onChange,
    tabs,
    normalColor = '#45556C',
    selectedColor = '#04385D',
    indicatorColor = '#04385D',
}) => {
    return (
        <Tabs
            value={value}
            onChange={onChange}
            aria-label="profile detail tabs"
            variant="scrollable"
            scrollButtons={false}
            sx={{
                '& .MuiTabs-indicator': {
                    background: indicatorColor,
                },
            }}
        >
            {tabs.map((tab) => (
                <Tab
                    key={tab.value}
                    label={tab.label}
                    value={tab.value}
                    sx={{
                        textTransform: 'none',
                        fontSize: '15px',
                        fontWeight: '500',
                        color: normalColor,
                        '&.Mui-selected': {
                            color: `${selectedColor} !important`,
                            fontWeight: 600,
                            [`& .${globalStyles.profileText}`]: {
                                color: `${selectedColor} !important`,
                                fontWeight: 600,
                            },
                        },
                    }}
                />
            ))}
        </Tabs>
    );
};

export default GlobalTabsComponent;

